import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
var boxStyles = css(["display:block;padding:8px 12px;border:1px solid ", ";border-radius:", ";background-color:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primaryLL;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.font;
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-m4dv3s-0"
})(["margin-top:12px;", " ", ""], getFont(0), boxStyles);
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-m4dv3s-1"
})(["padding:3px 0 0 3px;svg{width:16px;height:16px;margin-right:6px;}"]);
export var ViewMoreBlock = styled.div.withConfig({
  displayName: "partials__ViewMoreBlock",
  componentId: "sc-m4dv3s-2"
})(["", ""], getFont(-1));
export var ActionBtn = styled.button.withConfig({
  displayName: "partials__ActionBtn",
  componentId: "sc-m4dv3s-3"
})(["cursor:pointer;color:", ";transition:opacity 0.25s ease;&:hover{opacity:0.75;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.linkColor;
});